// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scanner-buttons {
  margin: 0px;
  position: absolute;
  bottom: 100px;
  width: 100vw;
  height: 50px;
  z-index: 11;
}

.scan-box {
  border: 2px solid #fff;
  box-shadow: 0 0 0 100vmax rgba(0, 0, 0, 0.5);
  content: "";
  display: block;
  left: 50%;
  height: 300px;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared-styles/barcode-scanner.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,sBAAA;EACA,4CAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;EACA,gCAAA;EACA,YAAA;AACF","sourcesContent":[".scanner-buttons {\r\n  margin: 0px;\r\n  position: absolute;\r\n  bottom: 100px;\r\n  width: 100vw;\r\n  height: 50px;\r\n  z-index: 11;\r\n}\r\n\r\n.scan-box {\r\n  border: 2px solid #fff;\r\n  box-shadow: 0 0 0 100vmax rgba(0, 0, 0, 0.5);\r\n  content: '';\r\n  display: block;\r\n  left: 50%;\r\n  height: 300px;\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 300px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
